export default "__VITE_ASSET__B5Whlq3Z__"